import * as constants from './constants';
import { audioInputSlice } from './slice';

export default { constants, audioInputSlice };
